export const PERMISSION_GROUPS = {
  RMS: 'rms',
  CAD: 'cad',
  GLOBALS: 'globals',
};
